import React from 'react';
import './ScorecardPopover.styl';
import classNames from 'classnames';
import CircularScore from 'components/pure/utils/CircularScore';

export default ({items}) => (
  <div>
    <h2 className="popover-header">Listen time</h2>
    {items.map(item => (
      <div className={classNames('history-action-item', 'percentage-item')} key={item.id}>
        <div className="percentage-wrapper">
          <CircularScore percentage={item.context.value} />
        </div>
      </div>
    ))}
  </div>
);
